module.exports = "/images/sala_viajero_pv01.jpg?1953eb72588f3b04f410b009148622b4";